import wxSettingsIndex from '@/views/wxSettings/wxSettingsIndex.vue'

export default {
  path: '/wxSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'wxSettingsIndex',
      name: 'wxSettingsIndex',
      component: wxSettingsIndex
    },


  ]
}
